export default __webpack_public_path__ + "media/images/upminster-1-66277451410281d6c83a266b56ec97fa.png";